import { HYDRATE } from "next-redux-wrapper";
import { ActionsSearchUsers } from "./actions";

const initialState = { data: [], status: "fetch_init", message: "" };

function storeSearchUsers(state = initialState, action) {

	switch (action.type) {

	case HYDRATE:
		return { ...state, ...action.payload.storeSearchUsers };
	case ActionsSearchUsers.LOAD_GET_SEARCH_USERS:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsSearchUsers.RES_GET_SEARCH_USERS:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsSearchUsers.ERR_GET_SEARCH_USERS:
		return {
			...state,
			data: action,
			status: "fetch_error",
			message: "Error...",
		};
	default:
		return { ...state };

	}

}

export default storeSearchUsers;
